import Bugsnag from '@bugsnag/js';
import { cts_secure } from '../app/cts';
import store from '../configureStore';
import apis from '../app/apis';

/**
 * Event Tracker: monitoring the action of the user.
 * send to the server what ever user done in the whole site
 *
 * @author Alireza Zebardast
 * @param {String} eventName
 * @param {String} paramValue
 *
 */
const eventTracker = async (eventName, paramValue) => {
  Bugsnag.leaveBreadcrumb('Event Tracker', {
    eventName,
    paramValue: (paramValue) ? JSON.stringify(paramValue) : ''
  });
  try {
    const state = store.store.getState();

    if (state.plugin.projectId) {
      const { projectId, pluginId, uuid } = state.plugin;
      const { districtId, localityId } = state.config;

      const payLoad = {
        pluginId,
        projectId,
        eventName,
        districtId,
        localityId,
        userKey: uuid,
        userName: 'N/A',
        langValue: 'N/A',
        device: 'browser',
        userIp: '127.0.0.1',
        sourceValue: 'my-waste plugin',
        paramValue: (paramValue) ? JSON.stringify(paramValue) : '',
        source_ts: new Date().toISOString()
      };

      const params = new URLSearchParams();

      Object.keys(payLoad).map((key) => params.append(key, payLoad[key]));

      const { data, status } = await cts_secure('post', apis.trackerApi, params);
      if (
        status !== 200
        && data.message !== 'OK'
      ) return undefined;

      return await Promise.resolve(data);
    }

    return undefined;
  } catch (e) {
    // CENTRY
    console.warn(`Error trackin event named ${eventName}`);
    return null;
    // return Promise.reject('Error');
  }
};

export default eventTracker;
